import {DIRECTION_NAME} from "../../constants";
import uuidv4 from "../../utils/uuidv4";
import {formulaAfterForBorderPrice, formulaForBorderPrice} from "../../pages/Home/helper";
import {isTest} from "../session";

const isInSerbia = (countryName) =>
    String(countryName || '').toLowerCase() === 'srbija' || String(countryName || '').toLowerCase() === 'serbia';

export const handleBusTicketItem = (state, itemLabel, directionType, passengers, returnTrip, selfSale, roundedPrice = true) => {
    const INVOICE_ITEMS = [];   // 1) koristi se zbog razdavanja na granici (pre/posle granice)
    const TICKET_ITEMS = []; // 2) koristi se za jedinstvenu stavku bez razdvajanja zbog baze
    function addOrUpdate(arr, {
        totalAmount,
        unitPrice,
        discountAmount,
        name,
        isAfterBorder,
        isReturnTicket,
        labels,
        passengerUid,
        isDiscountApplied,
        ticketType
    }) {
        const existing = arr.find(it =>
            it.unitPrice === unitPrice &&
            it.name === name &&
            it.isAfterBorder === isAfterBorder &&
            it.isReturnTicket === isReturnTicket
        );

        if (existing) {
            existing.quantity += 1;
            existing.passengerUid.push(...passengerUid);
            existing.totalAmount += totalAmount;
        } else {
            arr.push({
                totalAmount,
                quantity: 1,
                unitPrice,
                discount: discountAmount,
                name,
                isAfterBorder,
                isReturnTicket,
                labels,
                passengerUid: [...passengerUid],
                isDiscountApplied,
                ticketType
            });
        }
    }

    const pushSplit = (obj) => addOrUpdate(INVOICE_ITEMS, obj);
    const pushUnified = (obj) => addOrUpdate(TICKET_ITEMS, obj);

    passengers.forEach((passenger) => {
        const passUid = uuidv4();
        const discountName =
            passenger.discountPCT?.name && passenger?.discountPCT?.name !== "Osnovna karta"
                ? ` - ${passenger.discountPCT.name}` : "";

        let isDiscountApplied = false;
        let passengerPrice = state.priceOneWay;
        let returnPrice = state.priceReturnTicket;
        const monthlyPrice = state.priceMonthly;
        const priceDaily = state.priceDaily;

        let discountAmount = 0;
        let ticketType = null;

        // DNEVNA
        if (directionType === DIRECTION_NAME[2]) {
            const base = {
                totalAmount: priceDaily,
                unitPrice: priceDaily,
                discountAmount,
                name: `${state.depStationName} - ${state.arrStationName} - DNEVNA KARTA ${discountName}`,
                isAfterBorder: false,
                isReturnTicket: false,
                labels: itemLabel,
                passengerUid: [passUid],
                isDiscountApplied, // iz nekog razloga je true na rezervaciji
                ticketType
            };

            // Split i Unified su isti za dnevnu
            pushSplit(base);
            pushUnified(base);
            return;
        }

        // Popusti
        if (passenger.discountPCT) {

            isDiscountApplied = true;
            ticketType = { id: passenger.discountPCT.ticketTypeId};

            if (directionType === DIRECTION_NAME[0]) {
                // jedan smer
                if (passenger.discountPCT.priceOneWay == null) {
                    throw new Error(`Za popust "${passenger.discountPCT.name}" nije definisana cena za jedan smer`);
                }
                const roundPrice = passenger.applyDiscountOneWay && passenger?.applyRoundPrice;
                passengerPrice = roundPrice
                    ? Math.ceil(passenger?.discountPCT?.priceOneWay / 10) * 10
                    : passenger?.discountPCT?.priceOneWay;
                returnPrice = 0;
                discountAmount = state.priceOneWay - passengerPrice;

            } else {
                // povratna
                if (passenger.discountPCT.priceOneWay == null) {
                    throw new Error(`Za popust "${passenger.discountPCT.name}" nije definisana cena za jedan smer`);
                }
                if (passenger.discountPCT.priceReturnTicket == null) {
                    throw new Error(`Za popust "${passenger.discountPCT.name}" nije definisana cena za povratnu kartu`);
                }
                if (passenger.discountPCT.priceOneWay < passenger.discountPCT.priceReturnTicket) {
                    const roundPriceReturn = passenger.applyDiscountReturnTicket && passenger?.applyRoundPrice;
                    const roundPrice = passenger.applyDiscountOneWay && passenger?.applyRoundPrice;
                    passengerPrice = roundPrice
                        ? Math.ceil(passenger?.discountPCT?.priceOneWay / 10) * 10
                        : passenger?.discountPCT?.priceOneWay;

                    // razlika za povratni deo
                    returnPrice = roundPriceReturn
                        ? Math.ceil((passenger.discountPCT.priceReturnTicket - passengerPrice) / 10) * 10
                        : (passenger.discountPCT.priceReturnTicket - passengerPrice);

                    discountAmount = state.priceOneWay - passengerPrice;
                } else {
                    passengerPrice = passenger.discountPCT.priceOneWay / 2;
                    returnPrice = passengerPrice;
                    discountAmount = state.priceReturnTicket - passenger.discountPCT.priceReturnTicket;
                }
            }
        } else {
            // bez popusta
            returnPrice = returnPrice - passengerPrice; // za povratnu karta = totalReturn - oneWay deo
        }

        const isInternational =
            ((state.arrCountryName !== "Srbija" && state.arrCountryCode !== "RS") ||
            (state.depCountryName !== "Srbija" && state.depCountryCode !== "RS")) && selfSale === true;

        function computeTaxLabel(selfSale, countryName) {
            // računamo da su dozvoljeni "Srbija" / "Serbia" (case-insensitive)
            const inSerbia = isInSerbia(countryName);

            // Pravila:
            // 1) Ako je selfSale: u Srbiji -> E (10%), van Srbije -> G (0%)
            // 2) Ako NIJE selfSale: uvek G
            const useE = selfSale ? inSerbia : false;
            const prodCode = useE ? 'Е' : 'Г';
            // Test mapiranje: gde je G -> B, gde je E -> A
            const testCode = useE ? 'A' : 'B';

            return isTest() ? [testCode] : [prodCode];
        }

        // ===== JEDAN SMER =====
        if (directionType === DIRECTION_NAME[0]) {
            if (isInternational) {
                // SPLIT: razdvajamo pre/posle granice
                const ticketPriceBeforeBorder = formulaForBorderPrice(
                    passengerPrice, state.depBorderDistance, state.arrBorderDistance
                );
                const ticketPriceAfterBorder = formulaAfterForBorderPrice(
                    passengerPrice, state.depBorderDistance, state.arrBorderDistance
                );
                const depInSerbia = isInSerbia(state.depCountryName);
                let roundedPriceBeforeBorder;
                let roundedPriceAfterBorder;
                if (roundedPrice) {
                    roundedPriceBeforeBorder = Number((Math.ceil(ticketPriceBeforeBorder / 10) * 10).toFixed(2));
                    roundedPriceAfterBorder = Number((Math.floor(ticketPriceAfterBorder / 10) * 10).toFixed(2));
                } else if (depInSerbia) {
                    roundedPriceBeforeBorder = Math.round(ticketPriceBeforeBorder);
                    roundedPriceAfterBorder = Number((passengerPrice - roundedPriceBeforeBorder).toFixed(2));
                } else {
                    roundedPriceAfterBorder = Math.round(ticketPriceAfterBorder);
                    roundedPriceBeforeBorder = Number((passengerPrice - roundedPriceAfterBorder).toFixed(2));
                }
                pushSplit({
                    totalAmount: roundedPriceBeforeBorder,
                    unitPrice: roundedPriceBeforeBorder,
                    discountAmount,
                    name: `${state.depStationName}  - Jedan smer${discountName}`,
                    isAfterBorder: false,
                    isReturnTicket: false,
                    labels: computeTaxLabel(selfSale, state.depCountryName),
                    passengerUid: [passUid],
                    isDiscountApplied,
                    ticketType
                });

                pushSplit({
                    totalAmount: roundedPriceAfterBorder,
                    unitPrice: roundedPriceAfterBorder,
                    discountAmount,
                    name: `${state.arrStationName} - Jedan smer${discountName}`,
                    isAfterBorder: true,
                    isReturnTicket: false,
                    labels: computeTaxLabel(selfSale, state.arrCountryName),
                    passengerUid: [passUid],
                    isDiscountApplied,
                    ticketType
                });

                // UNIFIED: jedna stavka (bez razdvajanja)
                pushUnified({
                    totalAmount: passengerPrice,
                    unitPrice: passengerPrice,
                    discountAmount,
                    name: `${state.depStationName} - ${state.arrStationName} - Jedan smer${discountName}`,
                    isAfterBorder: false,
                    isReturnTicket: false,
                    labels: [
                        ...computeTaxLabel(selfSale, state.depCountryName),
                        ...computeTaxLabel(selfSale, state.arrCountryName)
                    ],
                    passengerUid: [passUid],
                    isDiscountApplied,
                    ticketType
                });
            } else {
                // domaće — i split i unified su isti (1 stavka)
                const base = {
                    totalAmount: passengerPrice,
                    unitPrice: passengerPrice,
                    discountAmount,
                    name: `${state.depStationName} - ${state.arrStationName} - Jedan smer${discountName}`,
                    isAfterBorder: false,
                    isReturnTicket: false,
                    labels: itemLabel,
                    passengerUid: [passUid],
                    isDiscountApplied,
                    ticketType
                };

                pushSplit(base);
                pushUnified(base);
            }

            // ===== POVRATNA =====
        } else {
            if (isInternational) {
                // SPLIT — OUTBOUND (jedan smer deo)
                const ticketPriceBeforeBorder = formulaForBorderPrice(
                    passengerPrice, state.depBorderDistance, state.arrBorderDistance
                );
                const ticketPriceAfterBorder = formulaAfterForBorderPrice(
                    passengerPrice, state.depBorderDistance, state.arrBorderDistance
                );
                // SPLIT — RETURN deo, ali obrnut smer granice
                const returnTicketPriceBeforeBorder = formulaForBorderPrice(
                    returnPrice, state.arrBorderDistance, state.depBorderDistance
                );
                const returnTicketPriceAfterBorder = formulaAfterForBorderPrice(
                    returnPrice, state.arrBorderDistance, state.depBorderDistance
                );

                const depInSerbia = isInSerbia(state.depCountryName);
                const beforeBorderRaw = ticketPriceBeforeBorder + returnTicketPriceAfterBorder; // strana depCountryName
                const afterBorderRaw = ticketPriceAfterBorder + returnTicketPriceBeforeBorder;  // strana arrCountryName
                const totalRoundtrip = passengerPrice + returnPrice;
                let roundedPriceBeforeBorderTotal;
                let roundedPriceAfterBorder;
                if (roundedPrice) {
                    roundedPriceBeforeBorderTotal = Number((Math.ceil(beforeBorderRaw / 10) * 10).toFixed(2));
                    roundedPriceAfterBorder = Number((Math.floor(afterBorderRaw / 10) * 10).toFixed(2));
                } else if (depInSerbia) {
                    roundedPriceBeforeBorderTotal = Math.round(beforeBorderRaw);
                    roundedPriceAfterBorder = Number((totalRoundtrip - roundedPriceBeforeBorderTotal).toFixed(2));
                } else {
                    roundedPriceAfterBorder = Math.round(afterBorderRaw);
                    roundedPriceBeforeBorderTotal = Number((totalRoundtrip - roundedPriceAfterBorder).toFixed(2));
                }

                pushSplit({
                    totalAmount: roundedPriceBeforeBorderTotal,
                    unitPrice: roundedPriceBeforeBorderTotal,
                    discountAmount: 0,
                    name: `${state.depStationName} - ${state.arrStationName} - Jedan smer${discountName}`,
                    isAfterBorder: false,
                    isReturnTicket: false,
                    labels: computeTaxLabel(selfSale, state.depCountryName),
                    passengerUid: [passUid],
                    isDiscountApplied,
                    ticketType
                });

                pushSplit({
                    totalAmount: roundedPriceAfterBorder,
                    unitPrice: roundedPriceAfterBorder,
                    discountAmount,
                    name: `${(returnTrip?.arrStationName || state.arrStationName)} - ${(returnTrip?.depStationName || state.depStationName)} - Povratna${discountName}`,
                    isAfterBorder: true,
                    isReturnTicket: true,
                    labels: computeTaxLabel(selfSale, state.arrCountryName),
                    passengerUid: [passUid],
                    isDiscountApplied,
                    ticketType
                });


                // UNIFIED — dve stavke: outbound (jedan smer) + return (povratna), svaka bez razdvajanja
                pushUnified({
                    totalAmount: passengerPrice,
                    unitPrice: passengerPrice,
                    discountAmount: 0,
                    name: `${state.depStationName} - ${state.arrStationName} - Jedan smer${discountName}`,
                    isAfterBorder: false,
                    isReturnTicket: false,
                    labels: [
                        ...computeTaxLabel(selfSale, state.depCountryName),
                        ...computeTaxLabel(selfSale, state.arrCountryName)
                    ],
                    passengerUid: [passUid],
                    isDiscountApplied,
                    ticketType
                });

                pushUnified({
                    totalAmount: returnPrice,
                    unitPrice: returnPrice,
                    discountAmount,
                    name: `${(returnTrip?.arrStationName || state.arrStationName)} - ${(returnTrip?.depStationName || state.depStationName)} - Povratna${discountName}`,
                    isAfterBorder: false,
                    isReturnTicket: true,
                    labels: [
                        ...computeTaxLabel(selfSale, state.arrCountryName),
                        ...computeTaxLabel(selfSale, state.depCountryName)
                    ],
                    passengerUid: [passUid],
                    isDiscountApplied,
                    ticketType
                });

            } else {
                // domaća povratna — i split i unified su isti (2 stavke)
                pushSplit({
                    totalAmount: passengerPrice,
                    unitPrice: passengerPrice,
                    discountAmount: 0,
                    name: `${state.depStationName} - ${state.arrStationName} - Jedan smer${discountName}`,
                    isAfterBorder: false,
                    isReturnTicket: false,
                    labels: itemLabel,
                    passengerUid: [passUid],
                    isDiscountApplied,
                    ticketType
                });

                pushSplit({
                    totalAmount: returnPrice,
                    unitPrice: returnPrice,
                    discountAmount,
                    name: `${(returnTrip?.arrStationName || state.arrStationName)} - ${(returnTrip?.depStationName || state.depStationName)} - Povratna${discountName}`,
                    isAfterBorder: false,
                    isReturnTicket: true,
                    labels: itemLabel,
                    passengerUid: [passUid],
                    isDiscountApplied,
                    ticketType
                });

                // Unified identično
                pushUnified({
                    totalAmount: passengerPrice,
                    unitPrice: passengerPrice,
                    discountAmount: 0,
                    name: `${state.depStationName} - ${state.arrStationName} - Jedan smer${discountName}`,
                    isAfterBorder: false,
                    isReturnTicket: false,
                    labels: itemLabel,
                    passengerUid: [passUid],
                    isDiscountApplied,
                    ticketType
                });

                pushUnified({
                    totalAmount: returnPrice,
                    unitPrice: returnPrice,
                    discountAmount,
                    name: `${(returnTrip?.arrStationName || state.arrStationName)} - ${(returnTrip?.depStationName || state.depStationName)} - Povratna${discountName}`,
                    isAfterBorder: false,
                    isReturnTicket: true,
                    labels: itemLabel,
                    passengerUid: [passUid],
                    isDiscountApplied,
                    ticketType
                });
            }
        }
    });

    return {
        invoiceItems: INVOICE_ITEMS,
        ticketItems: TICKET_ITEMS
    };
};

export const formulaForDiscount = (price, discount) => {
    if (discount > 0) {
        return (price * discount) / 100;
    }
    return 0;
};
